import React, {useCallback, useEffect} from 'react'
import {TaskFullscreenLayout} from './TaskFullscreenLayout'
import {IReduxState} from '../../redux/types/IReduxState'
import {useDispatch, useSelector} from 'react-redux'
import {IWindow} from './domain/IWindow'
import {TaskEditorWrapper} from './components/window/TaskEditorWrapper'
import {TaskDrawerModal} from './components/drawer/TaskDrawerModal'
import {authActions} from '../auth/redux/actions'
import {UserDto} from 'learndb-share'
import {taskActions} from './redux/actions'
import {getStructureByWindowStyle} from './utils'

const TaskEditorLayout: React.FC = () => {
  const dispatch = useDispatch()

  const user = useSelector<IReduxState, UserDto>((state) => state.auth?.user)
  const userAnonymous = useSelector<IReduxState, UserDto>((state) => state.auth?.userAnonymous)
  let currentWindowStyle: number
  if (user || userAnonymous) {
    currentWindowStyle = (user || userAnonymous).setting?.windowStyle
  }

  const isFullscreenMode = useSelector<IReduxState, boolean>((state) => state.task?.isFullscreenMode)
  const topLeftWindow = useSelector<IReduxState, IWindow>((state) => state.task?.topLeftWindow)
  const bottomLeftWindow = useSelector<IReduxState, IWindow>((state) => state.task?.bottomLeftWindow)
  const topRightWindow = useSelector<IReduxState, IWindow>((state) => state.task?.topRightWindow)
  const bottomRightWindow = useSelector<IReduxState, IWindow>((state) => state.task?.bottomRightWindow)

  const onSetWindowStyle = useCallback(
    (newStyle: number): void => {
      const newUser = user || userAnonymous
      dispatch(
        authActions.saveUserSetting({
          ...newUser,
          setting: {
            userId: newUser.userId,
            windowStyle: newStyle,
          },
        }),
      )
      dispatch(
        taskActions.setState({
          ...getStructureByWindowStyle(newStyle),
        }),
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, userAnonymous],
  )

  const windowStyleEventListener = useCallback(
    (evt): void => {
      if (evt.isComposing || evt.keyCode === 229) {
        return
      } else if (
        (evt.keyCode === 49 && evt.metaKey && evt.shiftKey) ||
        (evt.keyCode === 49 && evt.ctrlKey && evt.shiftKey)
      ) {
        if (currentWindowStyle !== 0) {
          onSetWindowStyle(0)
        }
      } else if (
        (evt.keyCode === 50 && evt.metaKey && evt.shiftKey) ||
        (evt.keyCode === 50 && evt.ctrlKey && evt.shiftKey)
      ) {
        if (currentWindowStyle !== 1) {
          onSetWindowStyle(1)
        }
      } else if (
        (evt.keyCode === 51 && evt.metaKey && evt.shiftKey) ||
        (evt.keyCode === 51 && evt.ctrlKey && evt.shiftKey)
      ) {
        if (currentWindowStyle !== 2) {
          onSetWindowStyle(2)
        }
      }
    },
    [currentWindowStyle, onSetWindowStyle],
  )

  useEffect(() => {
    document.addEventListener('keydown', windowStyleEventListener)
    return () => {
      document.removeEventListener('keydown', windowStyleEventListener)
    }
  }, [windowStyleEventListener])

  if (isFullscreenMode) {
    return <TaskFullscreenLayout onSetWindowStyle={onSetWindowStyle} />
  } else {
    return (
      <div className={'task-editor-layout'}>
        <TaskEditorWrapper
          topLeftWindow={topLeftWindow}
          bottomLeftWindow={bottomLeftWindow}
          topRightWindow={topRightWindow}
          bottomRightWindow={bottomRightWindow}
        />
        <TaskDrawerModal onSetWindowStyle={onSetWindowStyle} />
      </div>
    )
  }
}

export {TaskEditorLayout}
